import React from 'react';

import { Badge } from '../Badge';

import './Item.scss';
import { shopApi } from 'api';
import type { BadgeType } from '../Badge/Badge';

interface BadgesProps {
  item: shopApi.Item;
}

export const Badges: React.FC<BadgesProps> = ({ item }) => {
  const labelBadges = item?.attributes?.find(attr => attr.external_id === 'label');

  const vipBadges = item?.attributes?.find(attr =>
    attr.external_id?.includes('vip_points'),
  );

  return (
    <div className="item__badges">
      {labelBadges?.values?.map(value => (
        <Badge
          key={value.external_id}
          title={value?.value}
          type={value.external_id as BadgeType}
        />
      ))}
      {vipBadges?.values?.map(value => (
        <Badge key={value.external_id} title={`+${value?.value}  ∐`} type={'vip'} />
      ))}
    </div>
  );
};
